import store from "store";
//import { loader } from "../../store/Loader/LoaderAction";
import Auth from "utils/auth";
import Storage from 'shared/helpers/storage'
import { dispatch } from 'index'

export const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

export const requestHandler = request => {
  if (isHandlerEnabled(request)) {
   request.headers['Authorization'] = Storage.getItem('accessToken')
  //  store.dispatch(loader(true));
  }
  return request;
};

export const successHandler = response => {
 if (isHandlerEnabled(response)) {
  //  store.dispatch(loader(false));
  }
  return response;
};

export const errorHandler = error => {
  if (isHandlerEnabled(error.config)) {
    if(error.response && error.response.status === 401){
      dispatch({ type: 'UNAUTHORIZED' })
    }
   // store.dispatch(loader(false));
    // You can decide what you need to do to handle errors.
    // here's example for unautherized user to log them out .
    // error.response.status === 401 && Auth.signOut();
  }
  return Promise.reject({ ...error });
};
